import produce from 'immer';
import { SELECT_SORT_ORDER } from '../actions/actionTypes';

const initialState = [];

const sortBy = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case SELECT_SORT_ORDER: {
            state.forEach((orderItem) => {
                orderItem.selected = orderItem.value === payload;
            });
        }

        // skip default
    }
}, initialState);

export default sortBy;
